// ============================================================
// 生态公开数据 — 来自 HTML 原型
// 包含四大生态元数据、痛点、目标人群、FAQ 等
// ============================================================

// 图片资源 — 从 HTML 原型中提取的 base64 图片保存为文件
export const IMAGES = {
  hero: require('@/assets/img/ecosystem/hero.jpg'),
  partner: require('@/assets/img/ecosystem/partner.jpg'),
  service: require('@/assets/img/ecosystem/service.jpg'),
  supply: require('@/assets/img/ecosystem/supply.jpg'),
  solution: require('@/assets/img/ecosystem/solution.jpg'),
  ecosystem: require('@/assets/img/ecosystem/ecosystem.jpg')
};

export const ecosystems = [{
  slug: 'partner',
  index: '生态一',
  name: '合伙人生态',
  slogan: '从散兵游勇到铁血军团',
  image: IMAGES.partner,
  accent: 'gold',
  questions: ['项目从哪来？', '身份从哪来？'],
  intro: '加入易隆创合伙人生态，你不再是单打独斗的工程商。平台用一级资质、品牌背书与2000+合伙人的关系网络，为你完成一次彻底的"身份跃升"。',
  values: [
    ['身份跃升', '加入生态，你就是易隆创在当地的事业部总经理。用平台的一级资质、丰富业绩和品牌背书去谈项目，身份对等、底气十足。'],
    ['自主可控', '你的项目你做主。所有审批流程线上完成，资金自己管理，利润自己分配。给你老板的权利，不给你老板的负担。'],
    ['资源共享', '你的关系，我们帮你放大；你没有的关系，我们帮你连接。2000+合伙人就是2000+个关系节点，纵横拉通，高中低层全触达。']
  ],
  quote: '你有的关系，我们帮你放大；你没有的关系，我们帮你连接。',
  scenes: [
    ['资质不够接不了大项目', '用平台一级资质投标，合同体量与项目类型彻底打开。'],
    ['异地项目人生地不熟', '当地合伙人就是当地关系节点，平台帮你纵横拉通。'],
    ['利润分成说不清', '分润规则系统内事先约定，回款自动分账，清清楚楚。']
  ]
}, {
  slug: 'service',
  index: '生态二',
  name: '服务能力生态',
  slogan: '激活千亿闲置产能',
  image: IMAGES.service,
  accent: 'cyan',
  questions: ['闲置的交付能力，如何持续变成收入？', '陌生工单，如何放心接、按标准做、及时结？'],
  intro: '企业往往按业务高峰配置团队，淡季却仍要承担固定工资、社保与管理成本。易隆创把施工、安装调试、巡检和运维能力接入全国工单池，让闲置工时被看见、被匹配、被结算，让成本中心真正变成收益中心。',
  values: [
    ['弹性用人', '你的技术团队闲时录入平台接单变现，忙时从平台调用人员补位。从固定养人变成按需用人，成本中心变资本中心。'],
    ['异地交付', '你在外的项目不用派人舟车劳顿。平台匹配当地合伙人的交付团队，成本大降、效率倍增。'],
    ['零散生意', '分散、低价值的维保、巡检项目，平台统一承接后分派给本地合伙人，让每个人都有新生意机会。']
  ],
  quote: '人闲着，成本不会停；能力接上工单，闲置工时才会变成经营收益。',
  scenes: [
    ['项目断档工资照发', '团队闲时完成认证并进入工单池，空档期也能持续接单。'],
    ['外地项目派人太贵', '本地服务团队就近承接异地交付，减少差旅和临时组队成本。'],
    ['一次交付做完就结束', '交付完成后继续承接巡检与维保，把一次收入延伸为持续收益。']
  ]
}, {
  slug: 'supply',
  index: '生态三',
  name: '供应链生态',
  slogan: '集采共生，数据共赢',
  image: IMAGES.supply,
  accent: 'gold',
  questions: ['买什么？', '怎么便宜买？'],
  intro: '2000+合伙人的采购量汇聚成平台的议价权。集采降本、数据核价、金融垫付，让采购这个传统成本项，第一次变成你的利润来源。',
  values: [
    ['集采降本', '2000+合伙人的采购量汇聚成平台的议价权。你谈好的价格，平台再帮你谈一次，降下来的部分平台与你分享。'],
    ['数据赋能', '平台沉淀的海量采购数据和材料价格库，让你快速核价、精准报价，避免踩坑。'],
    ['金融支持', '针对优质项目，平台提供资金垫付，缓解你的周转压力。利息按天计算，回款自动冲抵，清清楚楚。'],
    ['精准对接', '供应商入驻平台，系统智能匹配商机，让好产品直达目标客户，降低获客成本，保障回款安全。']
  ],
  quote: '别人买材料是成本，你买材料是利润——差的就是一个平台的量。',
  scenes: [
    ['采购量小没议价权', '几千个合伙人一起采购，价格再降10%-20%。'],
    ['报价没底怕踩坑', '平台材料价格库快速核价，报价精准有底气。'],
    ['垫资压力资金链紧', '优质项目平台垫付，按天计息、回款冲抵。']
  ]
}, {
  slug: 'solution',
  index: '生态四',
  name: '解决方案生态',
  slogan: '制造奇迹的梦工厂',
  image: IMAGES.solution,
  accent: 'purple',
  questions: ['好产品，如何突破有限的销售半径？', '陌生合作，如何建立信任、顺利成交？'],
  intro: '你的产品已经足够好，缺的不是再多做几次无效推广，而是更广的市场触角和更稳的合作机制。易隆创连接全国2000+合伙人与持续涌入的信息化项目，让好方案走出有限市场，让陌生合作也能放心推进。',
  values: [
    ['全国曝光', '将企业能力、技术优势、资质专利与代表案例展示给全国合伙人，让每一次浏览、收藏和对接申请都成为新的市场触点。'],
    ['精准匹配', '平台依据擅长领域、核心能力标签和区域交付能力，将高度相关的项目机会主动推送给你，减少无效拓客和盲目POC。'],
    ['生态协同', '合伙人负责客户与商务，服务能力生态补充交付，供应链生态提供产品与资金支持，平台机制保障项目、合同、回款与分润。']
  ],
  quote: '你不必先养一支覆盖全国的销售队伍，也能拥有遍布全国的市场触角。',
  scenes: [
    ['产品有竞争力，却很少被目标客户看见', '把一次次零散推广，变成面向全国合伙人网络的持续曝光。'],
    ['销售团队有限，行业与区域拓展太慢', '不必先扩充庞大销售团队，借助生态触达更多真实项目机会。'],
    ['陌生合作顾虑多，客户保护和回款没保障', '项目报备、协同、合同与结算走平台，用机制降低合作风险。']
  ]
}];

export const locks = [
  ['枷锁一：用人成本高', '忙的时候人不够用，闲的时候工资照发。技术团队、项目经理、施工人员——养着是成本，不养又接不了活。项目断档两个月，几十万就是纯支出。'],
  ['枷锁二：供应商资源弱', '采购量小，没有议价权。同样的设备，大公司拿货价比你低10%到20%。供应商要求款到发货，甲方要求货到付款，资金链绷得像钢丝。'],
  ['枷锁三：核心竞争力少', '没有自研产品，没有专精技术，只能在低端市场卷价格。智慧医院、智慧水务利润丰厚，但技术门槛把你挡在门外，有关系没技术，干瞪眼。'],
  ['枷锁四：无品牌资质', '没有一级资质，连投标的门槛都够不着。挂靠别人，合同签别人的名字，利润大头被拿走，风险全留给你——做大了是别人的业绩，做砸了是你的责任。']
];

export const personas = [
  ['类型一', '纯工程型公司老板', '手下几十号人，项目断档工资一分不能少。有政府关系，但只能做传统弱电智能化，智慧类项目眼馋却没技术没方案。', '团队闲时接平台派单变现，忙时用平台人员补位。平台匹配智慧类方案，你出关系，方案商出技术，一起拿单。'],
  ['类型二', '中小型工程公司老板', '二级资质，优质项目门槛够不着。采购量小价格不好，养不起完整团队，缺标书、缺项目经理、缺设计师。', '用易隆创一级资质谈项目，能接的体量和类型完全不一样。标书、项目经理随用随取按次付费，集采价格优势明显。'],
  ['类型三', '企业客户经理', '能拿项目是因为有公司平台撑着。自己单干最怕项目拿下没人交付，过单钱在别人账上，分润靠口头约定，风险太大。', '注册成合伙人，利润分成系统里约定好，回款自动到你账户。资质、方案、采购、施工平台全部配齐，你只管商务。'],
  ['类型四', '厂家销售代表', '和客户关系很好，但只能卖自己厂家的产品，利润空间有限。灰色收入拿得胆战心惊，环境一差就睡不着觉。', '用易隆创身份把整个项目拿下来，产品走你厂家，其他部分平台交付。赚整个项目的钱，每一笔清清楚楚、安全合规。'],
  ['类型五', '产品代理商', '卖货多年最怕货款收不回，利润被厂家和客户两头挤压，想转型做项目但没资质没团队。', '钱怎么走你说了算，每笔收付款在自己APP上审批。平台把资质、方案、交付团队配齐，从卖产品变做项目，利润翻好几倍。'],
  ['类型六', '总包单位项目经理', '有权决定智能化分包给谁。传统方式拿点回扣，风险大不说，大头利润都让分包商赚了。', '介绍项目给平台拿安全合规服务费，或合伙干：你出关系平台出交付，利润你拿大头。无论哪种都更安全、赚得多。'],
  ['类型七', '人脉资源者', '有人脉，帮人介绍项目，分多少、什么时候给都是人情账。没有身份，没有安全感，业务做不大。', '你是易隆创正式的事业部总经理，有名片有身份。分润系统约定、回款自动到账，你只管拿项目，其余平台配齐。'],
  ['类型八', '招标代理/咨询公司', '能影响招标文件，机会宝贵，但操作上一定要确保安全。核心诉求是安全和利益最大化。', '项目作为平台合伙经营项目，全套资质和方案去投标，中标后你拿你的那份，所有流程合规合法，资金安全有保障。']
];

export const steps = [
  ['01', '注册成为合伙人', '下载易隆创APP，完成注册，获得专属账户。你就是生态的一员，拥有自己的云财务部和云企业。注册免费，不需要先掏钱。'],
  ['02', '报备项目，使用平台资源', '将手上的项目在平台报备，锁定经营权。根据项目需要，使用平台的资质投标、设计方案、采购降本、资金支持等服务。'],
  ['03', '深度协同，打破能力边界', '在平台上经营项目，体验全流程自主可控。你能做的生意类型更多了，能对接的客户层级更高了，背后是一个铁血军团。']
];

export const faqs = [
  ['易隆创平台是做什么的？', '易隆创是新基建领域首个互联网平台，专注于为具备项目获取能力的企业或个人提供项目经营全流程的资源支持与服务。简单说，你有关系，我们有资源，我们一起把项目做好，利润你拿大头。'],
  ['加入平台需要交钱吗？', '注册成为合伙人免费。使用平台资源时，平台会收取一定的管理费，从项目回款中扣除，你不需要先掏钱。'],
  ['平台能提供什么资源？', '四大生态资源：合伙人生态（一级资质、品牌背书、身份赋能）、服务能力生态（弹性用人、异地交付、维保服务）、供应链生态（集采降本、数据赋能、金融支持）、解决方案生态（行业解决方案、技术赋能、控标支持）。'],
  ['如何保证我的项目安全？', '所有项目线上审批，资金自主管理，利润自主分配。你是项目的老板，平台是你的服务商。对人的信任是一时的，对规则的信任才是永恒的。'],
  ['平台有多少合伙人？', '目前已有2000+合伙人，覆盖全国各省市。每一位合伙人都可以共享平台资源，也可以贡献自己的资源。']
];

export const serviceOrders = [
  { type: '标准化服务工单', title: '园区弱电设备巡检与故障排查', city: '江苏 · 苏州', price: '¥1,800 / 次', tags: ['视频监控', '网络设备', '2人'], status: '可报名', time: '2天内完成', desc: '完成园区监控、网络与门禁设备巡检，提交问题清单、处理记录与现场照片。' },
  { type: '标准化服务工单', title: '办公楼无线网络安装调试', city: '安徽 · 合肥', price: '¥3,200 / 单', tags: ['无线网络', '安装调试', '3人'], status: '待接单', time: '本周完成', desc: '完成无线AP安装、控制器调试、覆盖测试与验收资料整理。' },
  { type: '异地交付服务', title: '产业园机房与综合布线交付', city: '四川 · 自贡', price: '¥38,000 / 项', tags: ['综合布线', '机房工程', '本地团队'], status: '可竞价', time: '15天工期', desc: '承接机房设备安装、综合布线、标签整理、调试配合与竣工资料。' },
  { type: '异地交付服务', title: '职业院校门禁与考勤系统交付', city: '青海 · 西宁', price: '¥26,000 / 项', tags: ['门禁一卡通', '异地交付', '4人'], status: '招募中', time: '10天工期', desc: '完成门禁控制器、读卡器、考勤终端安装及联调，支持项目验收。' },
  { type: '异地维保服务', title: '连锁园区网络与监控年度维保', city: '江西 · 九江', price: '¥8,600 / 月', tags: ['驻场巡检', 'SLA', '可续签'], status: '可报名', time: '年度服务', desc: '每月巡检、故障响应、设备台账更新与季度报告，服务期满可续约。' },
  { type: '异地维保服务', title: '制造企业机房与网络季度巡检', city: '云南 · 丽江', price: '¥12,000 / 季', tags: ['机房', '网络', '季度巡检'], status: '待接单', time: '季度服务', desc: '完成机房环境、交换网络、UPS与链路健康检查，输出整改建议。' }
];

export const solutionItems = [
  { cat: '制造企业', name: '湖北大型制造企业工控系统安全加固项目', company: '项目阶段：方案比选 · 预算约600万', tags: ['工控安全', '本地化部署', '湖北'], match: '与网络安全类服务商能力高度匹配', icon: '制' },
  { cat: '能源', name: '西北能源企业生产网络纵深防御建设', company: '项目阶段：需求梳理 · 千万级机会', tags: ['能源央企', '网络安全', '西北区域'], match: '正在寻找具备行业经验的成熟服务商', icon: '能' },
  { cat: '智慧园区', name: '华南产业园数字化运营与安全一体化项目', company: '项目阶段：立项中 · 预算约800万', tags: ['智慧园区', '数字孪生', '安全运营'], match: '适合具备平台产品与联合售前能力的企业', icon: '园' },
  { cat: '医疗卫生', name: '三甲医院信息系统安全与后勤智慧化改造', company: '项目阶段：招标前 · 预算约500万', tags: ['智慧医院', '数据安全', '运维管理'], match: '优先匹配有医院案例的解决方案服务商', icon: '医' },
  { cat: '水利水务', name: '城乡供水管网监测与漏损分析建设项目', company: '项目阶段：方案征集中 · 预算约700万', tags: ['水利水务', '物联网', '数据分析'], match: '正在寻找可联合设计与交付的成熟方案', icon: '水' },
  { cat: '教育', name: '高职院校AI实训与数字校园升级项目', company: '项目阶段：商机跟进 · 预算约300万', tags: ['职业教育', 'AI应用', '数字校园'], match: '适合具备产品化能力和教育案例的服务商', icon: '教' }
];

export const supplyProjects = [
  { cat: '计算机网络系统', status: '新推荐', title: '南京某智慧园区网络设备采购项目', meta: '项目阶段：需求确认 · 江苏南京', tags: ['核心交换机', '无线覆盖', '原厂支持'], match: '96%匹配', deadline: '2小时内更新', icon: '网' },
  { cat: '安全防范系统', status: '热', title: '苏州制造企业视频监控与门禁系统升级', meta: '项目阶段：询价中 · 江苏苏州', tags: ['视频监控', '门禁一卡通', '本地服务'], match: '93%匹配', deadline: '今日18:00前', icon: '安' },
  { cat: '多媒体系统', status: '新推荐', title: '徐州职业院校多媒体教室改造设备采购', meta: '项目阶段：清单确认 · 江苏徐州', tags: ['智慧黑板', '音响系统', '录播设备'], match: '88%匹配', deadline: '本周内完成', icon: '多' },
  { cat: '机房工程', status: '', title: '武汉产业园数据中心机房设备集中采购', meta: '项目阶段：招标前 · 湖北武汉', tags: ['UPS', '精密空调', '机柜系统'], match: '90%匹配', deadline: '3天内更新', icon: '机' }
];

export const registerCopyByEco = {
  partner: {
    kicker: 'PARTNER ECOSYSTEM',
    title: '注册成为<span class="gold-text">项目合伙人</span>',
    desc: '你专注客户与项目，平台补齐资质、方案、采购、交付、资金和分润机制，让关系真正变成可经营的项目能力。',
    perks: [
      ['权', '自有项目自主申请、审批与付款'],
      ['证', '一级资质、品牌背书与四大生态资源'],
      ['财', '专属账户、云财务部与清晰分润']
    ],
    callout: ['客户你来拿，项目平台一起做', '注册免费，平台管理费从项目回款中扣除。']
  },
  service: {
    kicker: 'SERVICE CAPABILITY ECOSYSTEM',
    title: '让闲置能力<span class="gradient-text">持续变现</span>',
    desc: '把施工、安装调试、巡检和维保能力接入全国工单池，让闲置工时被看见、被匹配、被结算。',
    perks: [
      ['证', '实名 + 技能双认证，入驻免费'],
      ['单', '标准工单、异地交付与异地维保'],
      ['盾', '过程可视、验收结算与资金安全']
    ],
    callout: ['人闲着，成本不会停；接上工单，能力才会变成收益', '完善技能、区域与案例信息，平台匹配会更精准。']
  },
  supply: {
    kicker: 'SUPPLY CHAIN ECOSYSTEM',
    title: '让真实项目<span class="gold-text">主动找到你</span>',
    desc: '把产品体系、经营能力和服务区域接入真实采购需求，让项目推荐、产品询价和品牌曝光持续发生。',
    perks: [
      ['荐', '项目推荐与商机大厅持续获客'],
      ['询', '产品询价、品牌推广与特价宣传'],
      ['盾', '原厂直达、合作留痕与回款保障']
    ],
    callout: ['从跑断腿找项目，到项目带着明确需求找上门', '供应商入驻免费，资料越完整，推荐越精准。']
  },
  solution: {
    kicker: 'SOLUTION ECOSYSTEM',
    title: '让好产品<span class="purple-text">走出有限市场</span>',
    desc: '把成熟方案、技术优势、资质专利与成功案例展示给全国合伙人，让更多真实项目持续看见你。',
    perks: [
      ['眼', '全国曝光、谁看过我与对接申请'],
      ['准', '行业、能力和区域标签精准匹配'],
      ['盾', '客户保护、合同协同、回款与分润机制']
    ],
    callout: ['酒香也怕巷子深，生态让市场触角延伸到全国', '完成认证后进入解决方案服务商资源池。']
  }
};

export const unifiedRoles = {
  partner: {
    name: '易隆创业务平台', short: '易', eco: '合伙人生态',
    color: '#ffd05c', soft: 'rgba(255,208,92,.13)', border: 'rgba(255,208,92,.25)', glow: 'rgba(255,208,92,.22)',
    desc: '项目经营、审批、采购、合同与云财务',
    metrics: [['3', '项目数量'], ['2', '待我审核'], ['186万', '待回款']],
    stats: [
      ['推进中项目', '3', '较上周 +1'],
      ['待审批事项', '2', '需要今日处理'],
      ['本月回款', '186万', '完成率 72%'],
      ['平均采购降本', '12%', '平台二次议价']
    ],
    tasks: [
      ['投标保证金申请待审批', '制造企业数字化改造项目', '今天 16:30 前'],
      ['采购询价结果待确认', '智慧园区网络设备采购', '已节省 11.8%'],
      ['收入合同待签署', '某职业院校信息化项目', '对方已确认']
    ],
    quick: [
      ['项目报备', '新建并提交客户项目'],
      ['采购询价', '参数核价与一键询价'],
      ['合同管理', '收入、支出合同管理'],
      ['云财务部', '资金、付款与分润']
    ],
    menu: [
      ['概', '经营概览'], ['项', '项目中心'], ['审', '审批中心'],
      ['采', '采购中心'], ['合', '合同管理'], ['财', '云财务部']
    ]
  },
  solution: {
    name: '解决方案商系统', short: '方', eco: '解决方案生态',
    color: '#ad8cff', soft: 'rgba(173,140,255,.13)', border: 'rgba(173,140,255,.24)', glow: 'rgba(173,140,255,.22)',
    desc: '方案上架、商机匹配与协同推进',
    metrics: [['16', '方案数量'], ['4', '本月方案浏览'], ['2', '新的对接']],
    stats: [
      ['方案浏览量', '16', '本月 +28%'],
      ['高匹配商机', '4', '建议优先跟进'],
      ['对接申请', '2', '等待响应'],
      ['推进中项目', '3', '1个进入合同']
    ],
    tasks: [
      ['湖北工控安全项目高度匹配', '预算约 600 万', '匹配度 96%'],
      ['广东园区合伙人申请对接', '已浏览系统安全方案', '15分钟前'],
      ['能源行业方案资料待补充', '缺少最新交付案例', '建议今日完成']
    ],
    quick: [
      ['方案管理', '上架与维护解决方案'],
      ['商机雷达', '查看高匹配真实项目'],
      ['对接申请', '处理合伙人合作申请'],
      ['能力主页', '维护资质与代表案例']
    ],
    menu: [
      ['概', '业务概览'], ['方', '方案中心'], ['机', '商机雷达'],
      ['接', '对接管理'], ['项', '项目协同'], ['数', '经营数据']
    ]
  },
  service: {
    name: '服务商系统', short: '服', eco: '服务能力生态',
    color: '#63d7ff', soft: 'rgba(99,215,255,.13)', border: 'rgba(99,215,255,.24)', glow: 'rgba(99,215,255,.22)',
    desc: '标准工单、异地交付与维保服务',
    metrics: [['9', '可接工单'], ['3', '待到场任务'], ['62万', '本月服务额']],
    stats: [
      ['可接工单', '9', '覆盖 6 个城市'],
      ['待到场任务', '3', '最近 2 小时内'],
      ['本月服务额', '62万', '较上月 +18%'],
      ['维保续签率', '78%', '持续服务能力']
    ],
    tasks: [
      ['南京弱电安装调试工单', '预计 2 人天', '明日 09:00 到场'],
      ['苏州园区网络巡检', '异地维保服务', '等待接单确认'],
      ['合肥机房整改验收', '标准化服务工单', '材料待上传']
    ],
    quick: [
      ['工单大厅', '查看并承接匹配工单'],
      ['我的任务', '到场、过程与验收'],
      ['服务团队', '人员、技能与档期'],
      ['结算中心', '验收与服务费结算']
    ],
    menu: [
      ['概', '工单概览'], ['厅', '工单大厅'], ['任', '我的任务'],
      ['团', '团队管理'], ['验', '交付验收'], ['结', '结算中心']
    ]
  },
  supply: {
    name: '供应商系统', short: '供', eco: '供应链生态',
    color: '#ffb84d', soft: 'rgba(255,184,77,.13)', border: 'rgba(255,184,77,.24)', glow: 'rgba(255,184,77,.22)',
    desc: '项目推荐、产品询价与供货协同',
    metrics: [['7', '项目推荐'], ['3', '待响应询价'], ['5', '待审核报备']],
    stats: [
      ['新增项目推荐', '7', '今日新机会'],
      ['待响应询价', '3', '最晚 18:00'],
      ['待供货订单', '5', '2单需跟进物流'],
      ['本月成交额', '280万', '较上月 +21%']
    ],
    tasks: [
      ['核心交换机与无线AP询价', '南京智慧园区', '18:00 前报价'],
      ['视频存储扩容项目推荐', '苏州制造企业', '匹配度 93%'],
      ['一卡通设备待发货', '徐州职业院校', '需更新物流单号']
    ],
    quick: [
      ['项目推荐', '查看精准匹配项目'],
      ['产品询价', '快速响应采购需求'],
      ['品牌主页', '维护企业与产品资料'],
      ['供货管理', '订单、物流与回款']
    ],
    menu: [
      ['概', '供应概览'], ['荐', '项目推荐'], ['询', '产品询价'],
      ['品', '产品中心'], ['货', '供货管理'], ['款', '回款结算']
    ]
  }
};

export function accentClass(a) {
  return a === 'gold' ? 'gold-text' : a === 'purple' ? 'purple-text' : 'gradient-text';
}

export function ecoBySlug(slug) {
  return ecosystems.find(e => e.slug === slug);
}

export function compactCopy(text, max = 54) {
  return text.length > max ? text.slice(0, max).replace(/[，、；：]$/, '') + '…' : text;
}
